import { render, staticRenderFns } from "./kalenderEvent.vue?vue&type=template&id=1474dc9c&"
import script from "./kalenderEvent.vue?vue&type=script&lang=js&"
export * from "./kalenderEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports